// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__fSWZw","hosts":"footer_hosts__rlAKS","partnerLogo":"footer_partnerLogo__gx4oc","container":"footer_container__qpHRc","section":"footer_section__v_klZ"};